// extracted by mini-css-extract-plugin
module.exports = {"form":"ActivityEditForm_form__sISED","error":"ActivityEditForm_error__33l-L"};